import { render } from "./LocationOnlineBookingSettings.vue?vue&type=template&id=458494ae&scoped=true"
import script from "./LocationOnlineBookingSettings.vue?vue&type=script&lang=js"
export * from "./LocationOnlineBookingSettings.vue?vue&type=script&lang=js"

import "./LocationOnlineBookingSettings.vue?vue&type=style&index=0&id=458494ae&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458494ae"]])

export default __exports__